import React from 'react'
import AdminNavbar from './AdminNavbar'
import { Outlet } from 'react-router-dom'
import { Box, Container } from '@mui/material'

const AdminDashboard = () => {
  return (
    <Box>
      <AdminNavbar />
      <Box sx={{px: 7, pt: 4}}>
        <Outlet />
        </Box>
    </Box>
  )
}

export default AdminDashboard
